(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9436],{

/***/ 89529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-multiuser-account-access/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-08",
      tag: "eBay",
      title: "eBay Multi-User Account Access: What is it, and why is it essential in growing your business?",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Managing one or multiple stores on eBay entails a lot of time and attention to detail to ensure that everything is running smoothly, from creating the listings to printing the shipping labels."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Having a partner or an assistant to help with the workload is an obvious solution. However, some business owners may have reservations about giving other people access to their accounts for fear of putting their sensitive data at risk."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay understands this predicament. That\u2019s why they have in place a feature called Multi-User Account Access. With MUAA, authorized users can perform tasks for your online store without having to use your eBay log-in details to access your account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Using this feature can benefit you in three ways:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Help boost your productivity by letting your assistant or team of assistants perform tasks such as managing listings and monitoring orders on your behalf."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Protect your account from unauthorized use or unsanctioned exposure of your confidential information."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Allow designated user/s to get in touch with eBay support on your behalf in resolving an open case."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How does MUAA work? How do I get started?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["First, identify the two roles needed in setting up the Multi-User Account Access. The primary user or the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Delegator"
        }), " (usually you, the store owner, or your store manager) will determine the secondary user or the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Delegatee"
        }), " (usually a virtual assistant or a team member) and assign the tasks they will be allowed to execute on your behalf. Both roles should be logged in on the Seller Hub platform."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Second, send an invitation to the Delegatee or Delegatees using an email address that is already associated or not yet associated with an eBay account (they need to immediately make one using the same email address). The invitation is valid for 24 hours, after which it will automatically expire if unaccepted. If you\u2019ve accidentally sent an invitation to the wrong email address and would like to revoke it, you may do so \u2013 just go to the \u201CAuthorized users\u201D page on My eBay."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once the Delegatee accepts the invitation, they can already function according to the permissions granted by the Delegator. To avoid any confusion and technical problems, keep in mind the following:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While there\u2019s no limit to the number of Delegators that can grant permissions and the number of Delegatees for whom these permissions are obtained, users are highly encouraged to keep separate eBay accounts for exclusive use as a Delegator and a Delegatee."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once you use an account for Delegator purposes, you can\u2019t use it anymore to accept an invitation as a Delegatee for another user. In the same way, once an account serves as a Delegatee, it cannot be used anymore to function as a Delegator."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is advisable to use your main eBay account, the one you use in buying or selling, for Delegator purposes and set up a new account to fulfill your duties as a Delegatee."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Since a Delegatee can function as a support member for multiple accounts, they can switch from one account to another. A blue banner on top of the Selling Hub page indicates the account they are acting on behalf of. If they want to switch to another account, they may do so by clicking on the blue banner to see the options.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What kinds of permissions can I grant a Delegatee?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There\u2019s a variety of permissions you can grant a Delegate depending on the needs of your business and your working arrangement with them. Note that Delegatees would have neither the visibility to contents nor the capability to perform actions beyond what you have granted them."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In terms of listings, you can opt to let them create and edit listing drafts and publish and revise listings. If you need help with researching products, you can grant your Delegatee permission to do product research on your behalf with the use of Terapeak if you are subscribed to it.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When it comes to orders, you can allow them to simply view orders and download order reports."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If it\u2019s shipping you need help with, you can let them add a shipping tracking number and print shipping labels."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You may also grant your authorized users permission to reach out directly to the eBay support team on your behalf if the need arises. However, you must instruct your Delegates to disclose to the support representative on the call that they are accessing your account using MUAA."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To modify the permissions, you have granted a particular Delegatee, locate the \u201CAccount Permissions\u201D page on your My eBay, specifically under \u201CAction.\u201D You can view all of the invitations you\u2019ve sent in the past on this tab. It is also where the outstanding invitations pending acceptance are. You may also revoke here an invitation you\u2019ve sent within 24 hours."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "These flexible options make eBay\u2019s Multi-User Account Access a useful feature for store owners like you who would like to scale their eBay business up without compromising the security of their accounts."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There\u2019s also another tool to help you stay productive in managing your online store, especially if you also sell on other marketplaces. OneShop is an all-in-one app that lets you cross-list to Mercari and Poshmark. Sign up for the free 7-day trial today to experience how it can contribute to the efficiency and success of your online business!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-multiuser-account-access.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "eBay Multi-User Account Access: What is it, and why is it essential in growing your business?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Having extra hands in running your eBay store is great, but making use of a feature that provides you with flexibility in delegating tasks is even better. Know all about this feature in this article."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-multiuser-account-access"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-multiuser-account-access"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "eBay Multi-User Account Access: What is it, and why is it essential in growing your business?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Having extra hands in running your eBay store is great, but making use of a feature that provides you with flexibility in delegating tasks is even better. Know all about this feature in this article."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 50332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-multiuser-account-access",
      function () {
        return __webpack_require__(89529);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(50332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);